
export const MODULE_NAME = 'home'

export const HOME_ROUTES = {
  INDEX: `${MODULE_NAME}.index`,
} as const
